export default {
  addTestList ({ commit }, payload) {
    commit('addTestList', payload)
  }
}
